import React from 'react';
import { ActivityIndicator, Flex, List, Toast, WhiteSpace, Modal } from 'antd-mobile';
import { findEventWithViewedCounted, findShareConfig } from "../../../services/evt";
import { findMicrosites, findMicrositeConfig } from "../../../services/microsite";
import { findInvitationBgm } from "../../../services/invitationBgm";
import moment from 'moment';
import { connect } from "react-redux";
import TweenOne from 'rc-tween-one';
import ReactAudioPlayer from 'react-audio-player';
import Iconfont from "../../../components/Iconfont/Iconfont";
import '@/style/sudoku.less';
import { weixinShare } from "../../../utils/share";
import ShareQrcodeModal from "../ShareQrcodeModal";
import guestsUrl from "../../../style/imgs/invitation-page/guests.png";
import defaultcover from "../../../style/imgs/invitation-page/default.png";


const Item = List.Item;
const Brief = Item.Brief;

class Sudoku extends React.Component {
    constructor(props) {
        super(props);
        this.playerRef = null;
        this.state = {
            data: null,
            onPlay: true,
            musicUrl: null,
            micrositeData: [],
            loading: true,
            event: {
                data: null,
            },

        }
    }

    componentDidMount() {

        this.fetchEvent(this.props.params.id);
        this.fetchMusic();

    }
    //查询活动
    fetchEvent = (id) => {
        findEventWithViewedCounted(Object.assign({ id: id })).then(res => {
            if (res.code == 200) {
                this.setEventData(res.data);
            } else {
                Toast.fail(res.msg, 1);
                this.props.router.push(`/mobile/cancelactivityresult`);
            }
        }).catch(err => {
            Toast.fail("访问异常", 1);
        }).finally(() => {
        })
    }
    //查询模块
    fetchMicrosites = () => {
        findMicrosites({ eventId: this.props.params.id, enabled: true }).then(res => {
            if (res.code == 200) {
                this.setState({
                    micrositeData: res.data,
                    loading: false,
                })
            } else {
                Toast.fail(res.msg, 1);
            }
        }).catch(err => {
            Toast.fail("访问异常", 1);
        }).finally(() => {
        })
    }
    fetchMicrositesConfig = () => {
        findMicrositeConfig({ eventId: this.props.params.id }).then(res => {
            if (res.code == 200) {
                this.setState({
                    data: res.data,
                })
                this.fetchMicrosites();
            } else {
                Toast.fail(res.msg, 1);
            }
        }).catch(err => {
            Toast.fail("访问异常", 1);
        }).finally(() => {
        })
    }
    //SETEVENT
    setEventData = (data) => {
        document.title = data.header.name;
        //分享
        this.setShareConfig(data);
        this.setState({
            event: {
                data: data,
            },
        })

        this.fetchMicrositesConfig();

    }
    //分享
    setShareConfig = (data) => {
        findShareConfig({ eventId: data.header.id }).then(res => {
            if (res.code == 200) {
                let shareData = {};
                if (res.data) {
                    shareData = {
                        title: res.data.title ? res.data.title : data.header.name,
                        des: res.data.brief ? res.data.brief : `${data.header.beginTime}开始 ${data.header.address}`,
                        img: res.data.image ? res.data.image : (data.header.banner ? data.header.banner : 'https://img.qdj8.cn/event-default.png'),
                    };
                } else {
                    shareData = {
                        title: data.header.name,
                        des: `${data.header.beginTime}开始 ${data.header.address}`,
                        img: data.header.banner ? data.header.banner : 'https://img.qdj8.cn/event-default.png',
                    };
                }
                //分享
                weixinShare(shareData, true);
            } else {
                Toast.fail(res.msg, 1);
            }
        }).catch(err => {
            Toast.fail("访问异常", 1);
        }).finally(() => {
        })

    }

    showModal = (type) => {
        this.setState({
            type: type,
            visible: true,
        })
    }

    //音乐
    fetchMusic = () => {
        if (this.props.location.query.musicId) {
            findInvitationBgm({ id: this.props.location.query.musicId }).then(res => {
                if (res.code == 200) {
                    this.setState({
                        musicUrl: res.data.url
                    })

                } else {
                    Toast.fail(res.msg, 1);
                }
            })
        }

    }
    //播放暂停
    onPlayFun = () => {
        this.setState({
            onPlay: !this.state.onPlay,
        }, () => {
            if (this.state.onPlay) {
                this.playerRef.audioEl.play();
            } else {
                this.playerRef.audioEl.pause();
            }
        })
    }


    ref = player => {
        let that = this;
        that.playerRef = player;
        window.wx.ready(function () {
            if (that.playerRef) {
                let play = function () {
                    that.playerRef.audioEl.play();
                    document.removeEventListener("touchstart", play, false);
                };
                that.playerRef.audioEl.play();
                document.addEventListener("WeixinJSBridgeReady", function () {
                    play();
                }, false);
                document.addEventListener('YixinJSBridgeReady', function () {
                    play();
                }, false);
                document.addEventListener("touchstart", play, false);
            }
        });


    }


    render() {

        const { event, micrositeData, data, loading } = this.state;

        const agenda = (
            event.data &&
            <div>
                {event.data.agenda.length > 0 ?
                    <List className='activity-agenda'>
                        {event.data.agenda.map((obj, index) => {
                            return <Item key={index} multipleLine><Iconfont style={{ color: '#39C5C1' }} libname="ckicon" type="shijian" /> {obj.date}
                                <span style={{ marginLeft: 20 }}>
                                    {moment(obj.fromTime, 'HH:mm').format("HH:mm")} ~ {moment(obj.toTime, 'HH:mm').format("HH:mm")}
                                </span>
                                <Brief>
                                    <p dangerouslySetInnerHTML={{ __html: obj.content ? obj.content.replace(/\n/g, "<br/>").replace(/\r\n/g, "<br>").replace(/\s/g, "&nbsp;") : '' }}></p>
                                </Brief>
                            </Item>
                        })}
                    </List>
                    :
                    <div style={{ lineHeight: '70px' }}>
                        暂无日程
                        </div>}
            </div>
        )
        const guests = (
            event.data &&
            <div>
                {event.data.guests.length > 0 ?
                    <List className='activity-guests'>
                        {event.data.guests.map((obj, index) => {
                            return <Flex key={index} justify='start' align='start' className='activity-guests-flex'>
                                <div className='guests-head'>
                                    <img src={obj.avatarUrl ? obj.avatarUrl : guestsUrl} alt="" />
                                </div>
                                <Item multipleLine >{obj.name}
                                    <Brief>
                                        <p dangerouslySetInnerHTML={{ __html: obj.introduction ? obj.introduction.replace(/\n/g, "<br/>").replace(/\r\n/g, "<br>").replace(/\s/g, "&nbsp;") : '' }}></p>
                                    </Brief>
                                </Item>
                            </Flex>
                        })}
                    </List>
                    :
                    <div style={{ lineHeight: '70px' }}>
                        暂无嘉宾
                    </div>}
            </div>
        )
        const basicInfo = (
            event.data &&
            <div>
                <div className="signup-sub-title">信息</div>
                <List className="activity-info">
                    {!event.data.header.freeEvent && <Item extra={<span style={{ color: '#FD7926', fontSize: 12 }}>{event.data.header.freeEvent ? '免费' : '收费'}</span>}>类型：
                    </Item>}
                    <Item >名称： {event.data.header.name}</Item>
                    <Item >开始： {moment(event.data.header.beginTime, "YYYY-MM-DD HH:mm:ss").format("YYYY-MM-DD HH:mm")}</Item>
                    <Item >结束： {moment(event.data.header.endTime, "YYYY-MM-DD HH:mm:ss").format("YYYY-MM-DD HH:mm")}</Item>
                    {event.data.header.organizers && event.data.header.organizers.length > 0 &&
                        <Item>
                            <Flex align={'start'}>
                                <span style={{ letterSpacing: 4, flexShrink: 0 }}>主办方：</span>
                                <div>
                                    {event.data.header.organizers.map((o, index) => <p key={index}>{o}</p>)}
                                </div>
                            </Flex>
                        </Item>}
                    {event.data.header.collaborators && event.data.header.collaborators.length != 0 ?
                        <Item>
                            <Flex align={'start'}>
                                <span style={{ letterSpacing: 4, flexShrink: 0 }}>协办方：</span>
                                <div>
                                    {event.data.header.collaborators.map((o, index) => <p key={index}>{o}</p>)}
                                </div>
                            </Flex>
                        </Item> : ''
                    }
                    {event.data.header.contractors && event.data.header.contractors.length != 0 ?
                        <Item>
                            <Flex align={'start'}>
                                <span style={{ letterSpacing: 4, flexShrink: 0 }}>承办方：</span>
                                <div>
                                    {event.data.header.contractors.map((o, index) => <p key={index}>{o}</p>)}
                                </div>
                            </Flex>
                        </Item> : ''
                    }
                    {event.data.header.customOrganizer && JSON.parse(event.data.header.customOrganizer).map((obj, index) => (
                        <Item key={index}>
                            <Flex align={'start'}>
                                <span style={{ flexShrink: 0, maxWidth: 110 }}>{obj.name}：</span>
                                <div>
                                    {
                                        obj.value.indexOf(',') > -1 ?
                                            obj.value.split(',').map((v, vindex) => (<p key={vindex}>{v}</p>))
                                            :
                                            obj.value.split('，').map((v, vindex) => (<p key={vindex}>{v}</p>))
                                    }
                                </div>
                            </Flex>
                        </Item>
                    ))}
                    <Item extra={<a href={`tel:${event.data.header.contactPhone}`}><Iconfont style={{ fontSize: 20, color: '#1296db' }} libname="ckicon" type="dianhua" /></a>}>联系电话：{event.data.header.contactPhone}</Item>
                    <Item extra={<a href={`https://uri.amap.com/navigation?to=${event.data.header.lng},${event.data.header.lat},${event.data.header.address}&&mode=car&policy=1&src=mypage&coordinate=gaode&callnative=0`}><Iconfont
                        style={{ fontSize: 20, color: '#49c5d3' }} libname="ckicon" type="daohang" /></a>}>地点：{event.data.header.address}</Item>
                </List>
                {event.data.header.summary || event.data.posters.length > 0 ?
                    <div className="signup-sub-title">详情</div> : ''}
                {event.data.header.summary || event.data.posters.length > 0 ?
                    <div className='activity-describe'>
                        <div className='activity-describe-text' dangerouslySetInnerHTML={{ __html: event.data.header.summary ? event.data.header.summary.replace(/##PageBreak##/g, '').replace(/\n/g, "<br/>").replace(/\r\n/g, "<br>").replace(/\s/g, "&nbsp;") : '' }}></div>
                        <div className='activity-describe-img'>
                            {event.data.posters.map((obj, index) => {
                                return <img key={index} src={obj.url} alt="" />
                            })}
                        </div>
                    </div> : ''}
            </div>
        )






        return (
            loading ?
                <ActivityIndicator className='am-loading' animating={true} size="large" text="Loading..." />
                :
                <div className='sudoku-container'>
                    {this.state.musicUrl && <TweenOne
                        animation={{ rotate: 360, repeat: -1, duration: 1300, ease: 'linear' }}
                        paused={!this.state.onPlay}
                        className="music-icon"
                        onClick={() => this.onPlayFun()}
                    >
                        <ReactAudioPlayer
                            // className='react-player'
                            ref={this.ref}
                            autoPlay={true}
                            loop={true}
                            src={this.state.musicUrl}
                            onPlay={val => console.log(val)}
                        // playing={this.state.onPlay}
                        // onReady={()=>{
                        //     this.setState({onPlay:true})
                        // }}
                        />
                    </TweenOne>}
                    <div className='cd-bg'>
                        <div
                            style={{ backgroundImage: `url(${data.bannerImg ? data.bannerImg : defaultcover})`, backgroundSize: '100% 100%' }}
                            className='cd-banner'>

                        </div>
                        <div
                            style={{ backgroundImage: `url(${data.backgroundImg ? data.backgroundImg : 'https://img.qdj8.cn/microsite/icon_wz_bg2.png'})`, backgroundSize: '100% 100%' }}
                            className='cd-content'>

                        </div>
                    </div>
                    <div className='sudoku-wapper cd-bg'>
                        <div className='cd-banner'>
                        </div>
                        <div className='sudoku-content cd-content' style={{ maxHeight: micrositeData.length > 6 ? '19.5rem' : '15rem' }}>
                            {micrositeData.map((obj, index) => {
                                return <div key={index} style={{ width: micrositeData.length == 4 ? '50%' : '33.3333%' }}>
                                    <div onClick={() => {
                                        if (obj.type) {
                                            if (obj.type == 'SIGNUP') {
                                                window.location.href = `/mobile/signup/${this.props.params.id}${this.props.location.search}`
                                            } else if (obj.type == 'MYINFO') {
                                                window.location.href = '/mobile/findvoucher?eventId=' + this.props.params.id
                                            } else {
                                                this.showModal(obj.type)
                                            }
                                        } else if (obj.linkType == 'IMAGE') {
                                            window.location.href = `/mobile/sudoku-page?image=${obj.link}&title=${obj.name}`;
                                        } else if (obj.linkType == 'TEXT') {
                                            localStorage.setItem('sudokuContent',obj.content)
                                            window.location.href = `/mobile/sudoku-page?title=${obj.name}`;
                                        } else {
                                            window.location.href = obj.link;
                                        }
                                    }}>
                                        {data.iconSize ?
                                            <img className='large-icon' src={obj.image} alt="" />
                                            :
                                            <div className='small-icon'>
                                                <img src={obj.image} alt="" />
                                                <p>{obj.name}</p>
                                            </div>}
                                    </div>
                                </div>
                            })}

                        </div>
                    </div>
                    <div className='share-btn'
                        onClick={() => this.setState({ shareQrcodeVisible: true })}>
                        <Iconfont libname="ckicon" type="fenxiang2" /> 分享
            </div>
                    {this.state.shareQrcodeVisible &&
                        <ShareQrcodeModal
                            evt={event}
                            hide={() => this.setState({ shareQrcodeVisible: false })}
                        />}
                    <Modal
                        // title={'基本信息'}
                        className={'sudoku-modal'}
                        visible={this.state.visible}
                        transparent
                        closable={false}
                        maskClosable={true}
                        onClose={() => this.setState({ visible: false })}
                    >
                        {this.state.type == 'AGENDA' && agenda}
                        {this.state.type == 'GUEST' && guests}
                        {this.state.type == 'DESCRIPTION' && basicInfo}
                    </Modal>
                </div>
        )
    }
}

Sudoku.defaultProps = {
    event: null,

};
const mapStateToPorps = state => {
    const evt = state.evt;
    return { evt };
};
const mapDispatchToProps = dispatch => ({
    //fetchEvtWithViewedCounted: bindActionCreators(fetchEvtWithViewedCounted, dispatch),

});

export default connect(mapStateToPorps, mapDispatchToProps)(Sudoku);



// WEBPACK FOOTER //
// ./src/containers/invitation-page/template/Sudoku.jsx